import { TaxFormType } from "@wingspanhq/payments/dist/interfaces";

export const selectorTypeFormLabel = (typeForm?: TaxFormType) => {
  const mapTypeFormLabel: Record<TaxFormType, string> = {
    [TaxFormType.Form1099Nec]: "1099-NEC",
    [TaxFormType.Form1099Misc]: "1099-MISC",
    [TaxFormType.T4ASlip]: "T4A Slip"
  };

  return typeForm ? mapTypeFormLabel[typeForm] : undefined;
};
